import { render, staticRenderFns } from "./DownloadProgress.vue?vue&type=template&id=915416fc"
import script from "./DownloadProgress.vue?vue&type=script&lang=js"
export * from "./DownloadProgress.vue?vue&type=script&lang=js"
import style0 from "./DownloadProgress.vue?vue&type=style&index=0&id=915416fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
